export default {
  plural: 'Downloads',
  singular: 'Download',
  toDownload: 'Download',
  failed: 'Archiving failed',
  preparing: 'Preparing download',
  noDownloads: 'No downloads'
};
